module.exports = __webpack_public_path__ + "static/media/banner-img4.b597b686.jpg";